export class CostCenter {
    id: number;
    identifier: string;
    name: string;
    type: string;
    parent: CostCenter;
    active: boolean;
}